// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "src_containers_Payments_js") return "static/css/async/" + chunkId + ".css";
  // return url for filenames based on template
  return "static/css/" + chunkId + ".css"
}